<template>
  <div class="centered">
    <div v-if="resetPressed">
      <password-reset @apierror="setApiError"
                      @apierrortext="setApiErrorText"
                      @cancel="cancelResetPassword">
      </password-reset>
    </div>
    <div v-else>
      <form id="loginForm" onsubmit="return false">
        <h1>Welcome</h1>
        <div>
          <input v-model="username"
                 class="login-input"
                 autofocus
                 type="email"
                 placeholder="email address"
                 size="30"
                 required
                 autocomplete="off"/>
        </div>
        <div>
          <input v-model="passphrase"
                 class="login-input"
                 type="password"
                 placeholder="password"
                 size="30"
                 required
                 autocomplete="off"/>
        </div>
        <div style="padding: 12px 15px;">
          <button type="submit" v-on:click="login()">sign in</button>
        </div>
        <div style="padding-top:3%;">
          <span class="icon-style" style="font-size:12pt;width:50%;" v-on:click="requestResetPassword()">Forgot your password?</span>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import PasswordReset from '@/components/login/PasswordReset'

export default {
  name: 'Login',
  emits: ['loginsuccess', 'username', 'apierror', 'apierrortext'],
  components: {
    PasswordReset,
  },
  data: function () {
    return {
      username: '',
      passphrase: '',
      resetPressed: false,
    }
  },
  methods: {
    login: function () {
      if (this.username.length && this.passphrase.length) {
        this.axios
            .post('session/authenticate', {
              userName: this.username,
              passPhrase: this.passphrase
            })
            .then(response => {
              this.$store.commit('login', response)
              this.$emit('username', this.username)
              this.$emit('loginsuccess', response)
            })
            .catch(error => {
              this.$store.commit('logout')
              this.username = ''
              this.passphrase = ''
              this.setApiError(true)
              this.setApiErrorText(error.response.statusText)
            })
      }
    },
    requestResetPassword: function () {
      this.resetPressed = true
    },
    cancelResetPassword: function () {
      this.resetPressed = false
    },
    setApiError: function(apiError) {
      this.$emit('apierror', apiError)
    },
    setApiErrorText: function(apiErrorText) {
      this.$emit('apierrortext', apiErrorText)
    },
  },
}
</script>
